import AppShell from "../components/AppShell";
import MoodIcon from "@mui/icons-material/Mood";
import SentimentNeutralIcon from "@mui/icons-material/SentimentNeutral";
import SentimentVeryDissatisfiedIcon from "@mui/icons-material/SentimentVeryDissatisfied";
import EmojiEmotionsIcon from '@mui/icons-material/EmojiEmotions';

function MeasuresResults() {
    return (
        <AppShell
            page="measureResults"
            expanded="is-expanded"
            contentPreset="analytics"
            title="สรุปผลมาตราการ"
            subtitle="เกณฑ์การประเมินนี้ใช้สื่อสารระดับผลลัพธ์ตามสัดส่วนการใช้มาตรการในแต่ละปี"
        >
            <div className="table-modern-wrap overflow-hidden">
                <div className="card-header bg-white border-0 pt-4 pb-3">
                    <h3 className="text-dark fw-normal fs-4 text-center" style={{ letterSpacing: '0.5px' }}>เกณฑ์การให้คะแนน</h3>
                </div>
                <div className="px-0">
                    <table className="table-modern">
                        <thead>
                            <tr>
                                <th className="text-start ps-5 py-3" style={{ width: '55%' }}>
                                    <span className="table-header-text">ระดับผลการประเมิน</span>
                                </th>
                                <th className="text-end pe-5 py-3">
                                    <span className="table-header-text">สัดส่วนการใช้</span>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr className="border-top">
                                <td className="text-start ps-5 py-3">
                                    <div className="d-flex align-items-center">
                                        <div className="icon-container bg-success-soft me-4">
                                            <EmojiEmotionsIcon className="text-success-dark" />
                                        </div>
                                        <div>
                                            <span className="text-dark fw-medium">ดีมาก</span>
                                            <div className="text-muted small">คะแนน 90-100</div>
                                        </div>
                                    </div>
                                </td>
                                <td className="text-end pe-5">
                                    <span className="text-dark fw-medium">มากกว่า 10%</span>
                                </td>
                            </tr>
                            <tr className="border-top">
                                <td className="text-start ps-5 py-3">
                                    <div className="d-flex align-items-center">
                                        <div className="icon-container bg-info-soft me-4">
                                            <MoodIcon className="text-info-dark" />
                                        </div>
                                        <div>
                                            <span className="text-dark fw-medium">ดี</span>
                                            <div className="text-muted small">คะแนน 70-89</div>
                                        </div>
                                    </div>
                                </td>
                                <td className="text-end pe-5">
                                    <span className="text-dark fw-medium">7 - 10%</span>
                                </td>
                            </tr>
                            <tr className="border-top">
                                <td className="text-start ps-5 py-3">
                                    <div className="d-flex align-items-center">
                                        <div className="icon-container bg-warning-soft me-4">
                                            <SentimentNeutralIcon className="text-warning-dark" />
                                        </div>
                                        <div>
                                            <span className="text-dark fw-medium">พอใช้</span>
                                            <div className="text-muted small">คะแนน 50-69</div>
                                        </div>
                                    </div>
                                </td>
                                <td className="text-end pe-5">
                                    <span className="text-dark fw-medium">5 - 6.99%</span>
                                </td>
                            </tr>
                            <tr className="border-top">
                                <td className="text-start ps-5 py-3">
                                    <div className="d-flex align-items-center">
                                        <div className="icon-container bg-danger-soft me-4">
                                            <SentimentVeryDissatisfiedIcon className="text-danger-dark" />
                                        </div>
                                        <div>
                                            <span className="text-dark fw-medium">ปรับปรุง</span>
                                            <div className="text-muted small">คะแนน ต่ำกว่า 50</div>
                                        </div>
                                    </div>
                                </td>
                                <td className="text-end pe-5">
                                    <span className="text-dark fw-medium">น้อยกว่า 5%</span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </AppShell>
    );
}

export default MeasuresResults;